export const resolver = async (request, store, ...params) => {
  let data = await request(...params);
  store(data);
};

export const handleCatchErrors = (error) => {
  if (error.status) {
    return error.response.data;
  } else {
    return {
      data: null,
      status: 1000,
      errorMessage: "Server Down",
      count: null,
    };
  }
};

export const responseDataFormat = (returnedDatadata) => {
  if (returnedDatadata?.data?.status) {
    const { data, status, errorMessage, count } = returnedDatadata.data;
    return { data, status, errorMessage, count };
  }
  return returnedDatadata;
};

export const responseDataFormatRedux = (returnedDatadata, type) => {
  const { data } = returnedDatadata;

  return {
    payload: data,
    type,
  };
};
export const responseDataFormatReduxAuth = (returnedDatadata, type) => {
  const { data } = returnedDatadata;

  return {
    payload: data?.data,
    type,
  };
};
